module.exports = __webpack_public_path__ + "static/media/2.7ddf62f1.jpg";